import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { PendingRequestsService } from '@frontend/sports/common/core/feature/pending-requests';
import { finalize } from 'rxjs';

export const pendingRequestsInterceptor: HttpInterceptorFn = (req, next) => {
    const pendingRequestsService = inject(PendingRequestsService);

    pendingRequestsService.requestStart();

    return next(req).pipe(finalize(() => pendingRequestsService.requestEnd()));
};
